export function useClearSafeStorage() {
  if (process.client) {
    localStorage.clear()

    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name.trim()}=;expires=${new Date(0).toUTCString()};path=/`;
    });
  }
}